<template>
  <div class="top-border animated fadeInUp" id="donate-stats">
    <PasswordRecovery />
  </div>
</template>

<script>
import PasswordRecovery from '../components/PasswordRecovery';

export default {
  components: {
    PasswordRecovery,
  },
  data() {
    return {};
  },
};
</script>
